export const showLoader = (showLoader: boolean) => ({
  type: "SHOW_LOADER",
  payload: showLoader,
});
